import css from 'styled-jsx/css';

export default css`
  .easy .pricing-card-title-divider,
  .easy :global(.button-turnkey) {
    background: var(--accent);
    color: white;
  }

  .easysite .pricing-card-title-divider,
  .easysite :global(.button-turnkey) {
    background: var(--accent-dark);
    color: white;
  }

  .enterprise .pricing-card-title-divider,
  .enterprise :global(.button-turnkey) {
    background: var(--enterprise-color);
    color: white;
  }
  .template-cta {
    font-size: 14px;
    font-weigth: 500;
    color: var(--primary);
    cursor: pointer;
  }
  :global(.pricing-card-description) {
    min-height: 130px;
    padding: 10px 20px;
  }
  @media only screen and (max-width: 460px) {
    :global(.pricing-card-description) {
      min-height: 0px;
    }
  }
  .pricing-card-discount-promo {
    font-size: 18px;
    font-weight: 500;
    text-decoration: line-through;
  }
  .pricing-card-saving-promo {
    font-size: 16px;
    margin-top: 4px;
  }
  .promo-circle {
    border-radius: 50px;
    width: 75px;
    height: 75px;
    right: 18px;
    top: 30px;
    display: flex;
    align-items: center;
    font-size: 24px;
    justify-content: center;
    background: linear-gradient(180deg, #005f4d, #008a73);
    border: 3px solid #02fbbf;
    box-shadow: 0px 1px 5px rgb(0 0 0 / 40%);
    position: absolute;
    color: white;
    font-weight: 600;
  }
`;
